'use client';

import { c as _c } from "react/compiler-runtime";
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
import { type AddressResult, AddressSearch } from './AddressSearch';
import { DaumPostcodeEmbed } from './DaumPostcodeEmbed';
interface PostcodeSearchProps {
  onComplete: (result: AddressResult) => void;
}

// 답례품 배송지 주소검색. 기본은 다음(카카오) 우편번호 임베드지만, KB Pay 인앱 웹뷰는
// 임베드 내부의 cross-origin iframe 검색 네비게이션을 외부 브라우저로 가로채 결과 선택이
// 끊긴다. KB 웹뷰에서만 우리 출처에서 도는 카카오맵 Geocoder 검색으로 대체한다.
export const PostcodeSearch = t0 => {
  const $ = _c(4);
  const {
    onComplete
  } = t0;
  const isKbWebview = useDeviceInfoStore(_temp);
  if (isKbWebview) {
    let t1;
    if ($[0] !== onComplete) {
      t1 = <AddressSearch onComplete={onComplete} />;
      $[0] = onComplete;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== onComplete) {
    t1 = <DaumPostcodeEmbed onComplete={data => onComplete({
      zonecode: data.zonecode,
      address: data.address,
      buildingName: data.buildingName
    })} />;
    $[2] = onComplete;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(state) {
  return state.webviewType === WEBVIEW_TYPE.KB_PAY;
}